export const ALBUM_TYPE_STEP = 'ALBUM_TYPE_STEP';
export const ALBUM_MANUAL_STEP = 'ALBUM_MANUAL_STEP';
export const ALBUM_AUTOMATIC_STEP = 'ALBUM_AUTOMATIC_STEP';
